import type {
  CareCaseChangeReason,
  CareCaseNextStep,
} from "@care-by-ella/contracts";

// TES-869 — Swedish for the care-case correction, for the doctor doing it.
//
// ⚠️ DERIVED, NOT CLINICALLY APPROVED COPY. Emelie wrote the reason CODES
// (Ö-209) but not their Swedish. These are our readings of what each code
// means, and they follow the same handling TES-810/Ö-183 set for the flag
// labels: usable now, marked as underlag rather than canon, and replaced
// verbatim the moment she writes them.
//
// Internal admin copy throughout — none of it reaches a patient. Ö-182's rule
// for the neighbouring handover reasons is the same instinct: the patient sees
// the outcome of care, never the internal reason for a correction.
export const CARE_CASE_REASON_LABEL: Record<CareCaseChangeReason, string> = {
  treatment_started_elsewhere:
    "Har påbörjat behandling hos annan vårdgivare efter F-01",
  patient_answered_incorrectly: "Patienten svarade fel i F-01",
  no_ongoing_prescription: "Inget recept eller pågående behandling att ta över",
  clinical_reassessment: "Omprövat vid klinisk bedömning",
  other: "Annat – ange orsak",
};

// What the patient owes next, in the doctor's words. Ö-210's rule is that none
// of these may read as "börja om" — each names a step genuinely missing, so
// the copy says what is left rather than what is being restarted.
export const CARE_CASE_NEXT_STEP_LABEL: Record<CareCaseNextStep, string> = {
  transfer_form_required: "Hon behöver fylla i F-07 om sin pågående behandling",
  targeted_completion_required:
    "Underlaget finns, men enskilda uppgifter saknas — välj dem nedan",
  transfer_review_ready: "Allt underlag finns — ärendet går till granskning",
  intake_required: "Hon behöver fylla i den medicinska hälsodeklarationen",
  meeting_booking_required: "Hon behöver boka ett vårdmöte",
  meeting_scheduled:
    "Ett vårdmöte är redan bokat — inget nytt ska bokas, invänta det",
  post_meeting_review:
    "Mötet är genomfört och dokumenterat — ärendet ligger hos dig",
};

// Case B is the only routing that asks the doctor to act immediately: he picks
// the exact CP-06 tasks instead of sending her through the whole of F-07
// again (TES-763). Naming it once here keeps that rule out of the component.
export function requiresImmediateAction(step: CareCaseNextStep): boolean {
  return step === "targeted_completion_required";
}
